import { FluentProvider } from '@fluentui/react-components';
import { createContext, ReactNode, useContext } from 'react';
import { darkThemeV9, lightThemeV9 } from 'themes/runtime/globalThemes-v9';

//
// The one theme provider of the app: Fluent UI v9 in light or dark. The color mode comes from the app
// context (appContext.useDarkMode); useAppTheme exposes it to the few places that need to know.
//
export enum ColorMode {
  Light = 1,
  Dark = 2,
}

interface ThemeContextValue {
  mode: ColorMode;
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

interface IUnifiedThemeProviderProps {
  mode: ColorMode;
  children: ReactNode;
}

export const UnifiedThemeProvider = (props: IUnifiedThemeProviderProps) => {
  const theme = props.mode === ColorMode.Dark ? darkThemeV9 : lightThemeV9;

  return (
    <ThemeContext.Provider value={{ mode: props.mode }}>
      <FluentProvider theme={theme} style={{ height: '100%', background: theme.colorNeutralBackground1 }}>
        {props.children}
      </FluentProvider>
    </ThemeContext.Provider>
  );
};

export const useAppTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useAppTheme must be used within UnifiedThemeProvider');
  }

  return ctx;
};
